/* global jQuery Cookies globalSiteSettings */
(function ($) {

    $(document).ready(function () {
        if (!Cookies.get('geo_data')) {
            window.debugLog('pulling');
            $.getJSON(globalSiteSettings.apiUrl + '/geo-ip', function (data) {
                window.debugLog(data);
                Cookies.set('geo_data', JSON.stringify(data), {expires: 1});
                // Generates content based on geo data in cookie
                geoBasedGen();
                window.defGeoIP.resolve(data);
            })
        } else {
            //Cookies are set!
            //window.debugLog('wheeee');
            //window.debugLog(JSON.parse(Cookies.get('geo_data')));
            geoBasedGen();
            window.defGeoIP.resolve(JSON.parse(Cookies.get('geo_data')));
        }
    })


    function getCookie(name) {
        var re = new RegExp(name + '=([^;]+)');
        var value = re.exec(document.cookie);
        return (value != null) ? unescape(value[1]) : null;
    }

// Generates content based on geo data in cookie
    function geoBasedGen() {
        // Gathers state data from cookie
        var geo_cookie = getCookie('geo_data');
        var stateProp = geo_cookie != null ? JSON.parse(geo_cookie) : {'state_abbreviation': 'XX'};

        window.debugLog(stateProp.state_abbreviation);
        /*
            UNCOMMENT THE STATEMENT TO ACTIVATE GEOBASE GENERATING CONTENT AND REMOVE THE **switch** LINE BELOW

            switch(stateProp.state_abbreviation){
        */
        switch ('FORCING DEFAULT') {

            case 'TX':
                $('#gen-banner').attr('style', 'background-image: url(/images/hero-img.png)!important');
                $('#TX').css('display', 'block');
                $('#gen-contanier').css('padding-bottom', '140px');
                break;

            case 'FL':
                $('#gen-banner').attr('style', 'background-image: url(/images/hero-img.png)!important');
                $('#FL').css('display', 'block');
                $('#gen-contanier').css('padding-bottom', '140px');
                break;

            default:
                $('#gen-banner').attr('style', 'background-image: url(/images/bg-hero.jpg)!important');
                $('#original-content').css('display', 'block');
                break;
        }

    }

})(jQuery);


/*
<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-left-md text-center-xs line-break-top banner-text-padding">
	<h2 class="text-uppercase row-break-top  no-padding choice-cash-font2">
		A NEW WAY TO BORROW!
	</h2>
	<h1 class="font-jumbo" style="letter-spacing: 0em; color: #151E17;">
		<span style="font-weight: bold; color: #fff;">
			Get CHOICECASH
		</span>
	</h1>
	<h2 class="row-break-top  no-padding choice-cash-font1">
		in as little as 24 hours
	</h2>
</div>
*/
